import { Alert } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./CloudConnectionStatus.module.scss"

export const CloudConnectionUnavailable = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.cloudConnection"
  })

  return (
    <Alert
      showIcon
      type="info"
      className={styles.container}
      title={t("unavailable")}
    />
  )
}
